<template>
    <div class='categroy'>
        <div class="categroy_header">
            <nav>
                <ul class="cl-ul cl-display--flex cl-flex--row cl-flex--wrap cl-align--center">
                    <li>
                        <a href="/" class="home" itemprop="item">
                            <svg class="svg-inline--fa fa-home fa-w-18" aria-hidden="true" focusable="false"
                                data-prefix="fas" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 576 512" data-fa-i2svg="">
                                <path fill="currentColor"
                                    d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z">
                                </path>
                            </svg><!-- <i class="fas fa-home"></i> Font Awesome fontawesome.com -->
                            <span style="display: none;" itemprop="name">首頁</span>
                        </a>
                    </li>
                    <li style="color: #000;">文章專欄</li>
                </ul>
            </nav>
        </div>
        <div class="title">
            <div class="block-inner"> <svg height="10" width="54">
                    <line x1="0" y1="5" x2="39" y2="5" style="stroke:#878787;stroke-width:1;shape-rendering:crispEdges;">
                    </line>
                </svg> <span class="Blog">文章專欄</span> <svg height="10" width="44">
                    <line x1="5" y1="5" x2="44" y2="5" style="stroke:#878787;stroke-width:1;shape-rendering:crispEdges;">
                    </line>
                </svg> </div>
        </div>
        <div class="container">
            <div class="blog-entry" v-for="items in article">
                <img @click="goArticle_id(items.id)" :src="items.img" alt="文章圖片" class="blog-image">
                <div class="blog-info">
                    <div class="blog-time">
                        <svg height="15" width="21" style="overflow:visible;">
                            <line x1="21" y1="17" x2="21" y2="-53"
                                style="stroke:#979797;stroke-width:1;shape-rendering:crispEdges;"></line>
                        </svg>
                        <span class="blog-date">{{ items.time }}</span>
                    </div>
                    <h3 @click="goArticle_id(items.id)" class="blog-title">{{ items.title }}</h3>
                    <p class="blog-summary">{{ items.desc }}</p>
                    <div class="read-more">
                        <div class="btns" @click="goArticle_id(items.id)">了解更多</div>
                    </div>
                </div>
            </div>
            <!-- Repeat for other entries -->
        </div>

    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    components: {},
    data() {
        return {
            item: [
                {
                    title: '為什麼雞胸要加添加劑：你需要知道的五個事實!',
                    time: '2023-07-16',
                    content: '為甚麼舒肥雞胸要加添加劑? 舒肥雞胸已經成為許多人減肥與健康餐的首選，但為了讓食物口感更好、保存時間更長，添加劑逐漸成為食品的主流 然而，你可能不知道的是，許多雞胸肉品牌中含有危險的添加劑，這些添加劑可能對我們的身體產生影響。   舒肥雞胸的添加劑 1.多磷酸鹽；焦磷酸鹽 舒肥雞胸通常添加磷酸鹽，以提高雞胸肉的濕度、增加吸水度讓肉品更足重，增加口感改善食物的風味和口感，讓大眾接受改良食品   2.修飾澱粉 修飾澱粉可以增加食品的黏性和穩定性，讓肉質更細膩',
                    html: '舒肥雞胸通常添加磷酸鹽，以提高雞胸肉的濕度、增加吸水度讓肉品更足重，增加口感改善食物的風味和口感，讓大眾接受改良食品',
                    img: 'https://img.shoplineapp.com/media/image_clips/64b3ad6ef5d589000e746ae8/original.jpg?1689496942'
                },
                {
                    title: '為什麼雞胸要加添加劑：你需要知道的五個事實!',
                    time: '2023-07-16',
                    content: '為甚麼舒肥雞胸要加添加劑? 舒肥雞胸已經成為許多人減肥與健康餐的首選，但為了讓食物口感更好、保存時間更長，添加劑逐漸成為食品的主流 然而，你可能不知道的是，許多雞胸肉品牌中含有危險的添加劑，這些添加劑可能對我們的身體產生影響。   舒肥雞胸的添加劑 1.多磷酸鹽；焦磷酸鹽 舒肥雞胸通常添加磷酸鹽，以提高雞胸肉的濕度、增加吸水度讓肉品更足重，增加口感改善食物的風味和口感，讓大眾接受改良食品   2.修飾澱粉 修飾澱粉可以增加食品的黏性和穩定性，讓肉質更細膩',
                    html: '舒肥雞胸通常添加磷酸鹽，以提高雞胸肉的濕度、增加吸水度讓肉品更足重，增加口感改善食物的風味和口感，讓大眾接受改良食品',
                    img: 'https://img.shoplineapp.com/media/image_clips/64983c2e6a063e000ee50b2f/original.jpg?1687698478'
                },
                {
                    title: '為什麼雞胸要加添加劑：你需要知道的五個事實!',
                    time: '2023-07-16',
                    content: '為甚麼舒肥雞胸要加添加劑? 舒肥雞胸已經成為許多人減肥與健康餐的首選，但為了讓食物口感更好、保存時間更長，添加劑逐漸成為食品的主流 然而，你可能不知道的是，許多雞胸肉品牌中含有危險的添加劑，這些添加劑可能對我們的身體產生影響。   舒肥雞胸的添加劑 1.多磷酸鹽；焦磷酸鹽 舒肥雞胸通常添加磷酸鹽，以提高雞胸肉的濕度、增加吸水度讓肉品更足重，增加口感改善食物的風味和口感，讓大眾接受改良食品   2.修飾澱粉 修飾澱粉可以增加食品的黏性和穩定性，讓肉質更細膩',
                    html: '舒肥雞胸通常添加磷酸鹽，以提高雞胸肉的濕度、增加吸水度讓肉品更足重，增加口感改善食物的風味和口感，讓大眾接受改良食品',
                    img: 'https://img.shoplineapp.com/media/image_clips/64b3ad6ef5d589000e746ae8/original.jpg?1689496942'
                },
                {
                    title: '為什麼雞胸要加添加劑：你需要知道的五個事實!',
                    time: '2023-07-16',
                    content: '為甚麼舒肥雞胸要加添加劑? 舒肥雞胸已經成為許多人減肥與健康餐的首選，但為了讓食物口感更好、保存時間更長，添加劑逐漸成為食品的主流 然而，你可能不知道的是，許多雞胸肉品牌中含有危險的添加劑，這些添加劑可能對我們的身體產生影響。   舒肥雞胸的添加劑 1.多磷酸鹽；焦磷酸鹽 舒肥雞胸通常添加磷酸鹽，以提高雞胸肉的濕度、增加吸水度讓肉品更足重，增加口感改善食物的風味和口感，讓大眾接受改良食品   2.修飾澱粉 修飾澱粉可以增加食品的黏性和穩定性，讓肉質更細膩',
                    html: '舒肥雞胸通常添加磷酸鹽，以提高雞胸肉的濕度、增加吸水度讓肉品更足重，增加口感改善食物的風味和口感，讓大眾接受改良食品',
                    img: 'https://img.shoplineapp.com/media/image_clips/64b3ad6ef5d589000e746ae8/original.jpg?1689496942'
                },
                {
                    title: '為什麼雞胸要加添加劑：你需要知道的五個事實!',
                    time: '2023-07-16',
                    content: '為甚麼舒肥雞胸要加添加劑? 舒肥雞胸已經成為許多人減肥與健康餐的首選，但為了讓食物口感更好、保存時間更長，添加劑逐漸成為食品的主流 然而，你可能不知道的是，許多雞胸肉品牌中含有危險的添加劑，這些添加劑可能對我們的身體產生影響。   舒肥雞胸的添加劑 1.多磷酸鹽；焦磷酸鹽 舒肥雞胸通常添加磷酸鹽，以提高雞胸肉的濕度、增加吸水度讓肉品更足重，增加口感改善食物的風味和口感，讓大眾接受改良食品   2.修飾澱粉 修飾澱粉可以增加食品的黏性和穩定性，讓肉質更細膩',
                    html: '舒肥雞胸通常添加磷酸鹽，以提高雞胸肉的濕度、增加吸水度讓肉品更足重，增加口感改善食物的風味和口感，讓大眾接受改良食品',
                    img: 'https://img.shoplineapp.com/media/image_clips/64b3ad6ef5d589000e746ae8/original.jpg?1689496942'
                },
            ]
        };
    },
    computed: {
        ...mapState('header', ['isarticle', 'article']),
    },
    watch: {},
    methods: {
        goArticle_id(id) {
            this.$router.push({ path: '/article/' + id });
        }
    },
    created() {
    },
    mounted() {
    },
}
</script>
<style lang='scss' scoped src="./index.scss"></style>
<style lang="scss" scoped>
.container {
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.title {
    margin: 30px 0;
    height: 20px;
    text-align: center;
}

.blog-entry {
    color: #4a4a4a;
    width: 410px;
    // overflow: hidden;
    max-width: 30%;
    padding: 0px 15px;
    margin-bottom: 30px;
    /* Adjust the width as needed */
}

.blog-image {
    cursor: pointer;
    width: 100%;
    height: auto;
    display: block;
}

.blog-info {
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.08);

}

.blog-time {
    padding-top: 15px;

    .blog-date {
        opacity: 0.4;
        font-size: 14px;
        font-weight: 600;
        padding-left: 5px;
        color: #4a4a4a;
    }
}

.blog-title {
    cursor: pointer;

    margin: 0;
    font-size: 23px;
    font-weight: 500;
    line-height: 1.5;
    padding: 14px 20px 20px 20px;
}

.blog-summary {
    padding: 0 20px;
    margin: 0 0 15px;
    font-size: 14px;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    max-height: 5.5em;
}

.read-more {
    text-align: right;
    padding: 15px 20px;

    .btns {
        border: none;
        display: inline-block;
        cursor: pointer;
        width: 120px;
        height: 38px;
        line-height: 38px;
        border-radius: 26px;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        background-color: #CD5C5C;
        color: #FFFFFF;
    }
}

// .read-more:hover {
//     background-color: #e65c00;
// }

@media (max-width: 991px) {
    .blog-entry {
        max-width: 45%;
    }
}

@media (max-width: 767px) {
    .blog-entry {
        max-width: 100%;
    }


}

@media (max-width: 767px) and (min-width: 500px) {
    .container {
        width: min-content;
    }
}

@media (max-width: 766px) {
    .blog-summary {
        display: none;
    }

    .read-more {
        display: none;
    }

    .blog-entry {
        margin-bottom: 10px;
    }
}</style>